import Rox from 'rox-browser';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';

export const featureFlagController = Rox;

/**
 * Rollout api key
 */
const RolloutProduction = '3d57064d-890a-46e4-9255-37f99eb0f9fa';
const RolloutStaging = '2dfb0ff9-d91c-44de-9e29-5ac379848174';
export const featureFlagKey = isProdVersion() ? RolloutProduction : RolloutStaging;

/**
 * Flags
 */
export const featureFlagFlags = {
  /**
   * Service Versions Controller
   */
  // Company Service
  CompanyServiceVersionProd: new featureFlagController.RoxString('prod'),
  CompanyServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // Auth Service
  AuthServiceVersionProd: new featureFlagController.RoxString('prod'),
  AuthServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // Admin Tools Service
  AdminToolsServiceVersionProd: new featureFlagController.RoxString('prod'),
  AdminToolsServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // Routes Service
  RoutingServiceVersionProd: new featureFlagController.RoxString('prod'),
  RoutingServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // IT Service
  ITServiceVersionProd: new featureFlagController.RoxString('prod'),
  ITServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // SSO Service
  SsoServiceVersionProd: new featureFlagController.RoxString('prod'),
  SsoServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // EndPoint Service
  EndpointServiceVersionProd: new featureFlagController.RoxString('prod'),
  EndpointServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // CreditsSystem Service
  CreditsSystemServiceVersionProd: new featureFlagController.RoxString('prod'),
  CreditsSystemServiceVersionStaging: new featureFlagController.RoxString('staging'),
  // SeCreditsSystem Service
  SeCreditsSystemServiceProd: new featureFlagController.RoxString('prod'),
  SeCreditsSystemServiceStaging: new featureFlagController.RoxString('staging'),
};

/**
 * Set the custom property in feature flag
 * @param key Searchable key, this key can be used to filter the access to the flag
 * @param value of this property
 */
function setCustomAttribute(key, value) {
  featureFlagController.setCustomStringProperty(key, value);
}

export function insertRolloutMetadata({
  user_email,
  user_name,
  user_id,
  user_group
} = {}) {
  // Should have Sentry installed and all user attributes
  const allAttributes = { user_email, user_name, user_id, user_group };
  if (Object.values(allAttributes).every(Boolean)) {
    for (const attr in allAttributes) {
      if (allAttributes.hasOwnProperty(attr)) {
        setCustomAttribute(`${attr}`, `${allAttributes[attr]}`);
      }
    }
    return true;
  }
  // If should install and do not have mandatory info
  console.error('It may be missing some mandatory info, check the following', allAttributes);
}

const alreadyShownFlagNotification = {};

const servicesToAddVersion = [
  'Company',
  'Auth',
  'AdminTools',
  'Routing',
  'IT',
  'Sso',
  'Endpoint',
  'CreditsSystem',
  'Panels',
  'ProprietaryPage',
];

const SENSITIVE_FLAGS = new Set([
  'SeCreditsSystemServiceProd',
  'SeCreditsSystemServiceStaging',
  ...servicesToAddVersion.flatMap(service => [
    `${service}ServiceVersionProd`,
    `${service}ServiceVersionStaging`,
  ]),
]);

/**
 * Start Rollout
 */
featureFlagController.register('default', featureFlagFlags);
featureFlagController.setup(featureFlagKey, {
  freeze: 'none', // Update in real-time
  configurationFetchedHandler: (fetcherResults) => {
    if (fetcherResults.hasChanges) {
      console.info('[Feature Flag] Configuration fetched successfully with changes.');
    } else {
      console.info('[Feature Flag] Configuration fetched — no changes detected.');
    }
  },
  impressionHandler: (reporting) => {
    const flagLabel = reporting.name.replace(/^default\./u, '');
    if (!Object.prototype.hasOwnProperty.call(featureFlagFlags, flagLabel)) {
      console.error(`Feature Flag is not mapped: ${flagLabel}`);
      return;
    }
    if (reporting.value && !alreadyShownFlagNotification[flagLabel] && !SENSITIVE_FLAGS.has(flagLabel)) {
      console.info(`Feature "${flagLabel}" is`, reporting.value);
      alreadyShownFlagNotification[flagLabel] = true;
    }
  },
});

/**
 * Show overrides locally, this is useful to test the featureflag
 * Uncomment the line above to test flags locally
 */
// featureFlagController.showOverrides();

